import { usePageContext } from 'application/contexts/PageContext';
import { getArticles } from 'application/repositories/articlesRepository';
import { PreviewCardProps } from 'ui/components/2-molecules/Card/PreviewCard/PreviewCard';
import { articlePreviewMapper } from 'helpers/mappers';
import useSWR from 'swr';

const getArticlesFromRepository = async (
	rootId: number,
	limit: number,
	offset: number,
	preview: boolean,
	previewData: Content.PreviewData,
): Promise<Articles.Article[]> => {
	return await getArticles({ rootId, limit, offset, preview, previewData });
};

interface ArticlesFetcherResult {
	articles?: PreviewCardProps[];
	isLoading: boolean;
}

export const ArticlesFetcher = (rootId: number, limit: number, offset: number): ArticlesFetcherResult => {
	const context = usePageContext();

	const { data, error } = useSWR([rootId, limit, offset, context.preview, context.previewData], getArticlesFromRepository, {
		revalidateOnFocus: false,
	});
	if (error) throw error;
	if (!data) return { isLoading: true };

	const mappedResults = data.map(articlePreviewMapper);
	return { articles: mappedResults, isLoading: false };
};
